fragment DetailedIndicator on Indicator {
  granularity
  aggregation
  mostRecentValue
  aggregatedValue
  period {
    start
    end
  }
  variation
  values {
    value
    date
  }
}
